var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89125 0.509098C2.23875 -0.165902 1.15875 -0.165901 0.506249 0.486599C-0.16875 1.1616 -0.16875 2.2191 0.506249 2.8716L8.31374 10.7241C8.62874 11.0391 9.05624 11.2191 9.50624 11.2191C9.95624 11.2191 10.3837 11.0391 10.6987 10.7241L18.5062 2.8716C18.8437 2.5566 19.0012 2.1291 19.0012 1.7016C19.0012 1.2516 18.8437 0.824099 18.5062 0.486599C17.8312 -0.165901 16.7737 -0.165902 16.1212 0.509098L9.50624 7.1466L2.89125 0.509098Z",
    fill: "#B3C1CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccArrow);
export default __webpack_public_path__ + "static/media/acc-arrow.ddcc41da1485cf74b635c140996b9255.svg";
export { ForwardRef as ReactComponent };